import React from 'react'
import TitleComponent from './TitleComponent'

export default function Title() { return <TitleComponent /> }
